import { render, staticRenderFns } from "./MWidgetMultiBatch.vue?vue&type=template&id=c6017624&scoped=true&lang=pug&"
import script from "./MWidgetMultiBatch.vue?vue&type=script&lang=js&"
export * from "./MWidgetMultiBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6017624",
  null
  
)

export default component.exports